<section class="content">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <a
              [routerLink]="['/admin-list/register']"
              class="btn btn-info float-right mb-3"
              >New Admin</a
            >
            <table 
              datatable 
              [dtOptions]="dtOptions"
              [dtTrigger]="dtTrigger" 
              class="row-border hover"
            >
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Admin Name</th>
                  <th style="width: 300px;">Email</th>
                  <th>Mobile No.</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody *ngIf="allAdmin?.length != 0">
                <tr *ngFor="let admin of allAdmin; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ admin.firstname | titlecase }} {{ admin.lastname | titlecase }}</td>
                  <td style="word-break: break-all;">{{ admin.email }}</td>
                  <td>{{ admin.mobile }}</td>
                  <td>{{ admin.status | titlecase }}</td>
                  <td>
                    <div class="btn-group">
                      <button 
                        type="button" 
                        class="btn btn-info"
                        data-bs-toggle="tooltip" title="Edit"
                        routerLink="/admin-list/edit-admin/{{ admin._id }}"
                      ><i class="fas fa-pen"></i></button>
                      <button 
                        *ngIf="admin.status === 'active'"
                        type="button" 
                        class="btn btn-success"
                        data-bs-toggle="tooltip" title="Inactivate"
                        (click)="changeStatus(admin._id, admin.status)"
                      ><i class="far fa-check-circle"></i></button>
                      <button 
                        *ngIf="admin.status !== 'active'"
                        type="button" 
                        class="btn btn-danger"
                        data-bs-toggle="tooltip" title="Activate"
                        (click)="changeStatus(admin._id, admin.status)"
                      ><i class="fas fa-ban"></i></button>
                      <button 
                        
                      type="button" 
                      class="btn btn-danger"
                      data-bs-toggle="tooltip" title="Delete"
                      (click)="deleteUser(admin._id)"
                    ><i class="fa fa-trash" aria-hidden="true"></i></button>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody *ngIf="allAdmin?.length == 0">
                <tr>
                  <td colspan="3" class="no-data-available">No data!</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </section>
  